<script>
import {Tag} from "element-ui"

export default {
  name: "payState",
  props: {
    payPrice: {
      type: [String, Number],
      default: 0
    },
    orderActualPrice: {
      type: [String, Number],
      default: 0
    }
  },
  // eslint-disable-next-line vue/require-render-return
  render(createElement, context) {

    let {payPrice, orderActualPrice} = this.$props;
    payPrice = Number(payPrice);
    orderActualPrice = Number(orderActualPrice);
    if (orderActualPrice === 0) return createElement(Tag, {
      props: {
        type: "success",
        size: "small"
      }
    }, "无需付款");
    let price = this.sub(orderActualPrice, payPrice);
    let obj = {};
    if (price === 0) {
      obj = {text: "已付款", type: "success"};
    } else if (price > 0 && payPrice > 0) {
      obj = {text: "部分付款", type: "warning"};
    } else {
      obj = {text: "待付款", type: "danger"};
    }

    return createElement(Tag, {
      props: {
        type: obj.type,
        size: "small"
      }
    }, obj.text)

  }
}
</script>


<style scoped lang="scss">

</style>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/payState.vue